var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendrier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701",
    "data-name": "Rectangle 1701",
    width: 37.627,
    height: 37.618,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-CALENDRIER"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CALENDRIER",
    clipPath: "url(#clip-CALENDRIER)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2622",
    "data-name": "Groupe 2622",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2620",
    "data-name": "Groupe 2620",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7026",
    "data-name": "Trac\\xE9 7026",
    d: "M34.972,5.9h-3.6V3.312a3.036,3.036,0,0,0-6.064,0V5.9H12.034V3.312a3.036,3.036,0,1,0-6.064-.318c0,.105,0,.212,0,.318V5.9H2.365A2.241,2.241,0,0,0,.117,8.09V34.964a2.255,2.255,0,0,0,2.248,2.248H35.084a2.135,2.135,0,0,0,2.136-2.134V8.09A2.241,2.241,0,0,0,34.972,5.9M28.345,1.4a1.894,1.894,0,0,1,1.91,1.881V8.09H26.493V3.312A1.848,1.848,0,0,1,28.278,1.4h.067M9.006,1.4a1.9,1.9,0,0,1,1.91,1.881V8.09H7.152V3.312A1.817,1.817,0,0,1,8.869,1.4,1.245,1.245,0,0,1,9,1.4ZM2.365,7.023H5.971V8.654a.531.531,0,0,0,.5.561.314.314,0,0,0,.065,0h4.874a.529.529,0,0,0,.561-.5.314.314,0,0,0,0-.065V7.079H25.294V8.654a.531.531,0,0,0,.5.561.314.314,0,0,0,.065,0h4.89a.531.531,0,0,0,.564-.5V7.079h3.662A1.116,1.116,0,0,1,36.1,8.148v3.315H1.242V8.148A1.124,1.124,0,0,1,2.365,7.023M35.084,36.145H2.365A1.126,1.126,0,0,1,1.24,35.02V12.588H36.1V35.076a1.021,1.021,0,0,1-.975,1.069h-.036",
    transform: "translate(0.145 0.144)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7027",
    "data-name": "Trac\\xE9 7027",
    d: "M9,0c.055,0,.111,0,.167,0a3.153,3.153,0,0,1,2.983,3.312V5.783H25.195V3.306A3.143,3.143,0,0,1,28.178.323c.055,0,.111,0,.167,0a3.154,3.154,0,0,1,3.148,2.987V5.783h3.488a2.37,2.37,0,0,1,2.357,2.3V35.074a2.255,2.255,0,0,1-2.253,2.255H2.365A2.379,2.379,0,0,1,0,34.965V8.09A2.371,2.371,0,0,1,2.357,5.783h3.5V3.312c0-.1,0-.214,0-.323A3.155,3.155,0,0,1,9,0ZM25.429,6.017H11.917V3.306A2.919,2.919,0,0,0,9.156.237c-.051,0-.1,0-.154,0A2.921,2.921,0,0,0,6.087,3c0,.1,0,.2,0,.306v2.71H2.357A2.135,2.135,0,0,0,.234,8.092V34.964A2.145,2.145,0,0,0,2.365,37.1H35.084A2.02,2.02,0,0,0,37.1,35.079V8.09a2.134,2.134,0,0,0-2.123-2.073H31.259v-2.7A2.92,2.92,0,0,0,28.344.553c-.051,0-.1,0-.154,0a2.909,2.909,0,0,0-2.761,2.758ZM8.96,1.284h.062a2.018,2.018,0,0,1,2.011,2V8.207h-4V3.315A1.937,1.937,0,0,1,8.863,1.287C8.9,1.286,8.928,1.284,8.96,1.284Zm.047.235H8.993a1.132,1.132,0,0,0-.117,0A1.7,1.7,0,0,0,7.268,3.306V7.973H10.8V3.283A1.784,1.784,0,0,0,9.022,1.519Zm19.354-.234a2.015,2.015,0,0,1,2.011,2V8.207h-4V3.312a1.964,1.964,0,0,1,1.9-2.027Zm1.777,6.688V3.283a1.781,1.781,0,0,0-1.777-1.764h-.084A1.731,1.731,0,0,0,26.61,3.308V7.973ZM2.365,6.906H6.088V8.661a.415.415,0,0,0,.389.438h.006a.2.2,0,0,0,.04,0h4.893a.413.413,0,0,0,.438-.387.221.221,0,0,0,0-.045v-1.7H25.411v1.7a.409.409,0,0,0,.1.3A.414.414,0,0,0,25.8,9.1h.006a.2.2,0,0,0,.04,0h4.908a.415.415,0,0,0,.44-.384V6.962h3.787a1.23,1.23,0,0,1,1.233,1.181V11.58H1.125V8.148A1.245,1.245,0,0,1,2.365,6.906Zm3.489.234H2.365A1.011,1.011,0,0,0,1.359,8.148v3.2H35.98v-3.2a1,1,0,0,0-1-.952H31.428v1.53a.649.649,0,0,1-.684.606H25.863a.432.432,0,0,1-.08,0,.648.648,0,0,1-.606-.681V7.2H12.087V8.648a.439.439,0,0,1,0,.082.646.646,0,0,1-.681.6H6.54a.431.431,0,0,1-.08,0,.648.648,0,0,1-.606-.681ZM1.123,12.471H36.212v22.6a1.138,1.138,0,0,1-1.087,1.189H2.365A1.247,1.247,0,0,1,1.123,35.02Zm34.855.234H1.357V35.02a1.012,1.012,0,0,0,1.009,1.008H35.117a.9.9,0,0,0,.861-.947V12.7Z",
    transform: "translate(0.145 0.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7028",
    "data-name": "Trac\\xE9 7028",
    d: "M9.781,12.216h4.5a.533.533,0,0,0,.564-.5v-4.5a.533.533,0,0,0-.5-.564H9.781a.533.533,0,0,0-.564.5.314.314,0,0,0,0,.065v4.44a.564.564,0,0,0,.564.564m.561-4.5h3.373v3.322H10.342Z",
    transform: "translate(11.397 8.222)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7029",
    "data-name": "Trac\\xE9 7029",
    d: "M17.82,6.624h-4.5a.529.529,0,0,0-.561.5.314.314,0,0,0,0,.065v4.442a.529.529,0,0,0,.5.561.314.314,0,0,0,.065,0h4.5a.529.529,0,0,0,.561-.5.314.314,0,0,0,0-.065V7.185a.56.56,0,0,0-.561-.561m-.564,4.5H13.884V7.8h3.373Z",
    transform: "translate(15.78 8.191)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7030",
    "data-name": "Trac\\xE9 7030",
    d: "M9.781,15.383h4.5a.533.533,0,0,0,.564-.5v-4.5a.533.533,0,0,0-.5-.564.314.314,0,0,0-.065,0h-4.5a.533.533,0,0,0-.564.5.314.314,0,0,0,0,.065v4.44a.533.533,0,0,0,.5.564h.065m.561-4.442h3.373v3.317H10.342Z",
    transform: "translate(11.397 12.138)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7031",
    "data-name": "Trac\\xE9 7031",
    d: "M17.82,9.816h-4.5a.531.531,0,0,0-.561.5.314.314,0,0,0,0,.065v4.44a.531.531,0,0,0,.5.564H17.82a.531.531,0,0,0,.561-.5.314.314,0,0,0,0-.065v-4.44a.531.531,0,0,0-.5-.564H17.82m-.564,4.442H13.884V10.941h3.373Z",
    transform: "translate(15.78 12.138)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7032",
    "data-name": "Trac\\xE9 7032",
    d: "M17.82,12.982h-4.5a.531.531,0,0,0-.561.5.314.314,0,0,0,0,.065v4.5a.529.529,0,0,0,.5.561.314.314,0,0,0,.065,0h4.5a.529.529,0,0,0,.561-.5.314.314,0,0,0,0-.065v-4.5A.562.562,0,0,0,17.82,12.982Zm-.564,4.5H13.884V14.107h3.373Z",
    transform: "translate(15.78 16.054)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7033",
    "data-name": "Trac\\xE9 7033",
    d: "M6.911,15.383a.533.533,0,0,0,.564-.5v-4.5a.533.533,0,0,0-.5-.564H2.413a.532.532,0,0,0-.561.5.314.314,0,0,0,0,.065v4.44a.533.533,0,0,0,.5.564H6.911Zm-3.99-4.442H6.294v3.317H2.921Z",
    transform: "translate(2.288 12.138)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7034",
    "data-name": "Trac\\xE9 7034",
    d: "M10.507,15.383a.531.531,0,0,0,.561-.5.315.315,0,0,0,0-.065v-4.44a.531.531,0,0,0-.5-.564H6.009a.533.533,0,0,0-.564.5v4.5a.533.533,0,0,0,.5.564h4.563ZM6.571,10.941H9.944v3.317H6.571Z",
    transform: "translate(6.734 12.138)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7035",
    "data-name": "Trac\\xE9 7035",
    d: "M6.961,13.058h-4.5a.533.533,0,0,0-.564.5v4.5a.533.533,0,0,0,.5.564.314.314,0,0,0,.065,0h4.5a.533.533,0,0,0,.564-.5.314.314,0,0,0,0-.065v-4.44a.533.533,0,0,0-.5-.564H6.961M6.4,17.5H3.027V14.183H6.4Z",
    transform: "translate(2.351 16.148)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7036",
    "data-name": "Trac\\xE9 7036",
    d: "M10.581,13.058h-4.5a.533.533,0,0,0-.564.5v4.5a.533.533,0,0,0,.5.564h4.561a.533.533,0,0,0,.564-.5.314.314,0,0,0,0-.065v-4.44a.533.533,0,0,0-.5-.564h-.065M10.02,17.5H6.647V14.183H10.02Z",
    transform: "translate(6.828 16.148)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7037",
    "data-name": "Trac\\xE9 7037",
    d: "M11.635,9.631A3.137,3.137,0,1,1,8.5,6.5a3.137,3.137,0,0,1,3.136,3.136",
    transform: "translate(6.63 8.033)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7038",
    "data-name": "Trac\\xE9 7038",
    d: "M15.374,16.175a3.137,3.137,0,1,1-3.136-3.136,3.137,3.137,0,0,1,3.136,3.136",
    transform: "translate(11.254 16.126)",
    fill: "#010101"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendrier);
export default __webpack_public_path__ + "static/media/CALENDRIER.f8f44992b816ccf5ddf921cc8f8fea0f.svg";
export { ForwardRef as ReactComponent };